import React from 'react';

const KeypadRow = (props) => (
    <div className="keypad-row" >
        {props.children}
    </div >
);

export default KeypadRow;
